import { cn } from "@/lib/utils";
import Image from "next/image";
import logo from "public/logo.webp";
import type { ComponentProps } from "react";

export type Props = Omit<ComponentProps<typeof Image>, "alt" | "src">;

export default function Logo({ ...props }: Props) {
  return (
    <Image
      width={190}
      height={42}
      className={cn("max-h-auto max-w-full", props.className)}
      draggable={false}
      {...props}
      src={logo}
      alt={"Joy Awards"}
    />
  );
}
